import { defineStore } from 'pinia';
import { useRoute } from 'vue-router';

export const useQueryStore = defineStore('query', () => {
  const route = useRoute();

  const getQueryParam = (paramName) => {
    return route.query[paramName] || null;
  };

  return { getQueryParam };
});
